import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=dc6b3bb2&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc6b3bb2')) {
      api.createRecord('dc6b3bb2', component.options)
    } else {
      api.reload('dc6b3bb2', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=dc6b3bb2&", function () {
      api.rerender('dc6b3bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/legal_entities/Index.vue"
export default component.exports